<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="User" title="Deleted Users" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
									<div class="row">
										<div class="col-md-12 d-flex">
											<span style="font-size: 20px; font-weight: bolder;">Deleted Users</span>
										</div>
										
									</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
									<div class="row">
										<div class="col-md-9">
											<label class="d-flex listing-length"><span>Show</span>
												<select class="form-select" v-model="listing_length" @change="fetchUsers()">
													<option value="5">5</option>
													<option value="10">10</option>
													<option value="20">20</option>
												</select>
												<span>entries</span>
											</label>
										</div>
										<div class="col-md-3">
											<input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchUsers()"/>
										</div>
									</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr>
											<th>Image</th>
											<th>Name</th>
											<th>Email & Mobile</th>
											<th>Registered On</th>
											<th>Reason</th>
											<th>Comments</th>
											<th>Options</th>
										</tr>
									</thead>
									<tbody v-if="Boolean(users.length)">
										<tr v-for="user in users" :key="user.id">
											<td><img :src="$image_url + user.image" class="img-fluid avatar-60 rounded-small" alt="image"/></td>
											<td> {{ user.name}} </td>
											<td> {{ user.email }}<br />{{ user.phone_number }} </td>
											<td> {{$filters.formatDateTime(user.created_at)}} </td>
											<td>{{ user.main_reason }}</td>
											<td>{{ user.reason }}</td>
											<td>
												<router-link :to="{ name: 'users.show', params: { id: user.id } }" class="btn btn-primary btn-sm mt-2 me-1">View</router-link>							
											</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="7" class="text-center">No data</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchUsers(page.url + '&limit=' + listing_length + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->

						</div>
					</div>
				</div>
			</div>
		</div>


		
	</div>
</template>


<script>
	export default {
		name: "DeletedUsers",
		data() {
			return {
				users: [],
				pagination: {},
				edit: false,
				user_status: {
					id: "",
					status: "",
				},
				keyword: "",
				listing_length: 10,
				token: "",
				errors: {},
				activate: false,
         		deactivate: false,

         		active_page_url: null,
			};
		},
		mounted() {},

		created() {
			this.fetchUsers();
		},

		methods: {
			fetchUsers(page_url = null) {
				let url = "/api/admin/users/deleted?limit=" + this.listing_length + "&keyword=" + this.keyword;
				page_url = page_url || url;

				if(localStorage.back_url) {
		            page_url = localStorage.back_url;  
		            localStorage.removeItem('back_url');
		        }    

				this.active_page_url = page_url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.users = responseData.data;
						this.pagination = responseData.links;
						console.log(this.users);
					})
					.catch((err) => console.log(err));
			},

			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.user = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },

			setBackURL(user_id) {
		         localStorage.setItem('back_url', this.active_page_url);
		         this.$router.push({ name: 'users.edit', params: { id: user_id } });
		    },

			
		},
	};
</script>
